export default {"src":"/_next/static/media/down-arrow.37ace593.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};